module.exports = __webpack_public_path__ + "img/briefcase-eye-outline.3428ac2f.svg";